<template>
  <div class="entryInfoBody">
    <Header />
    <div class="entryInfoMain" v-loading="loading">
      <Step :num='2' :authType="1" />
      <div class="infoMainBody">
        <div class="infoArea">
          <el-form :model="infoForm" :rules="rules" ref="infoForm" :hide-required-asterisk="false" label-width="180px" label-position="rigt">
            <el-form-item label="组织类型" prop="organizationType">
              <el-radio-group v-model="infoForm.organizationType" @change="setMode">
                <el-radio v-for="item in organizationType" :label="item.value" :key="item.value">{{ item.label }}
                  <el-popover popper-class="organizationPopover" placement="bottom" title="" trigger="hover" width="245" :content="item.title">
                    <i class="el-icon-warning ornanizationTitle" slot="reference"></i>
                  </el-popover>
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="infoForm.legalPersonIdentType == 0 && infoForm.organizationType != '3'" label="认证方式" prop="mode">
              <el-select v-model="infoForm.mode" placeholder="请选择认证方式" size="small" @change="setMode">
                <el-option v-for="item in authMode" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <p v-if="infoForm.mode==3">若您是法定代表人本人（外籍法人暂不支持）建议选择该方式<br />认证方便快捷，即刻完成</p>
              <p v-if="infoForm.mode==4">若贵公司开通对公账户，建议选择该方式，预计30分钟内完成</p>
              <!-- <br />可选择贵公司汇款或收款两种方式之一，完成打款认证 -->
            </el-form-item>
            <el-form-item v-if="infoForm.legalPersonIdentType != 0 || infoForm.organizationType == 3" label="认证方式" prop="mode">
              <el-select v-model="infoForm.mode" placeholder="请选择认证方式" size="small" @change="setMode">
                <el-option v-for="item in authTwoMode" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <p>若贵公司开通对公账户，建议选择该方式，预计30分钟内完成</p>
            </el-form-item>
            <div v-if="infoForm.organizationType == 1">
              <el-form-item label="企业名称" prop="companyName">
                <el-input v-model="infoForm.companyName" size="small" placeholder="请输入企业名称" maxlength="30"></el-input>
              </el-form-item>
              <el-form-item label="统一社会信用代码" prop="licenseNo">
                <el-input :disabled="flowType === '2' || useCustomInfo" v-model="infoForm.licenseNo" size="small" placeholder="请输入统一社会信用代码" maxlength="18"></el-input>
              </el-form-item>
            </div>
            <div v-if="infoForm.organizationType == 3">
              <el-form-item label="组织名称" prop="companyName">
                <el-input v-model="infoForm.companyName" size="small" placeholder="请输入组织名称" maxlength="30"></el-input>
              </el-form-item>
              <el-form-item label="统一社会信用代码或者其他代码" prop="licenseNo">
                <el-input :disabled="flowType === '2' || useCustomInfo" v-model="infoForm.licenseNo" size="small" placeholder="请输入统一社会信用代码或者其他代码" maxlength="30"></el-input>
              </el-form-item>
            </div>
            <div v-if="infoForm.organizationType == 2">
              <el-form-item label="个体工商户名称" prop="companyName">
                <el-input v-model="infoForm.companyName" size="small" placeholder="请输入个体工商户名称" maxlength="30"></el-input>
              </el-form-item>
              <el-form-item class="individualNo" label="统一社会信用代码或营业执照注册号" prop="licenseNo">
                <el-input :disabled="flowType === '2' || useCustomInfo" v-model="infoForm.licenseNo" size="small" placeholder="请输入统一社会信用代码或营业执照注册号" maxlength="18"></el-input>
              </el-form-item>
            </div>
            <el-form-item label="法定代表人姓名" prop="legalPersonName">
              <el-input v-model="infoForm.legalPersonName" size="small" placeholder="请输入法定代表人姓名" maxlength="60"></el-input>
            </el-form-item>
            <el-form-item label="法定代表人证件类型" prop="legalPersonIdentType">
              <el-select :disabled="infoForm.mode == 3 || infoForm.organizationType == 3" v-model="infoForm.legalPersonIdentType" placeholder="请选择法定代表人证件类型" size="small" @change="setIdenType">
                <el-option v-for="item in identType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="infoForm.legalPersonIdentType == 0 && infoForm.mode != 4" label="法定代表人身份证件号" prop="legalPersonId">
              <el-input v-model="infoForm.legalPersonId" size="small" placeholder="请输入法定代表人身份证件号" maxlength="18"></el-input>
            </el-form-item>
            <el-form-item v-if="infoForm.legalPersonIdentType != 0 || (infoForm.legalPersonIdentType == 0 && infoForm.mode == 4)" label="法定代表人身份证件号" prop="">
              <el-input v-model="infoForm.legalPersonId" size="small" placeholder="请输入法定代表人身份证件号" maxlength="20"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="lineBtn">
        <!-- <el-button size="mini" @click="getRoute">上一步</el-button> -->
        <el-button type="primary" size="mini" @click="setVerify">下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { validMobile } from '@/utils/validate'
export default {
  name: 'entryInfo',
  data() {
    return {
      loading: false,
      infoForm: {
        companyName: '',
        licenseNo: '',
        mode: 3,
        legalPersonName: '',
        legalPersonId: '',
        legalPersonIdentType: 0,
        organizationType: 1
      },
      countDown: 0,
      intervals: [],
      infoData: {},
      flowType: 0, //0:新认证1:继续认证2:重新认证\
      useCustomInfo: false, // 是否自定义数据
      rules: {
        organizationType: [
          { required: true, message: '请选择组织类型', trigger: 'change' }
        ],
        companyName: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        licenseNo: [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
          {
            validator: this.validLicenseNo,
            trigger: 'blur'
          }
        ],
        legalPersonName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          {
            validator: this.validLegalPersonName,
            trigger: 'blur'
          }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          {
            message: '请输入正确的手机号码',
            validator: validMobile,
            trigger: 'blur'
          }
        ],
        smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        legalPersonId: [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
          {
            validator: this.validIDcard,
            message: '请输入正确的18位身份证号码',
            trigger: 'blur'
          }
        ],
        legalPersonIdentType: [
          { required: true, message: '请选择证件类型', trigger: 'change' }
        ],
        mode: [{ required: true, message: '请选择认证方式', trigger: 'blur' }],
        identType: [
          { required: true, message: '请选择证件类型', trigger: 'blur' }
        ]
      },
      organizationType: [
        {
          value: 1,
          label: '企业',
          title:
            '企业指领取营业执照的有限责任公司、股份有限公司、非公司企业法人、国有企业、个人独资企业及其分支机构、来华从事经营活动和外国(地区)企业及其他经营单位'
        },
        {
          value: 2,
          label: '个体工商户',
          title:
            '个体工商户是指在法律允许的范围内，依法经核准登记，从事工商经营活动的自然人或者家庭'
        },
        {
          value: 3,
          label: '其他组织',
          title:
            '其他组织指在中华人民共和国境内依法注册、依法登记的机关、事业单位、社会团体、学校和民办非企业单位和其他机构'
        }
      ],
      identType: [
        {
          value: 0,
          label: '中国居民身份证'
        },
        {
          value: 1,
          label: '护照'
        },
        {
          value: 2,
          label: '港澳来往大陆通行证'
        },
        {
          value: 3,
          label: '台湾来往大陆通行证'
        }
      ],
      authMode: [
        // {
        //   value: 3,
        //   label: '法定代表人'
        // },
        // {
        //   value: 4,
        //   label: '对公打款'
        // }
      ],
      authTwoMode: [
        {
          value: 4,
          label: '对公打款'
        }
      ]
    }
  },
  mounted() {
    this.clearInterval()
    this.infoData = this.$store.state.userInfo
    this.getInfo()
  },
  methods: {
    isIDcard(e) {
      const cardRule = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/
      return cardRule.test(e)
    },
    validIDcard(rule, value, callback) {
      if (rule.required && !value) {
        callback(new Error('证件号不能为空'))
      } else {
        if (this.infoForm.legalPersonIdentType === 0) {
          if (!this.isIDcard(value) && value) {
            callback(new Error('请输入正确的证件号'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
    },
    validLicenseNo(rule, value, callback) {
      if (
        this.infoForm.organizationType === 1 &&
        !/^91[A-Za-z0-9]{16}$/.test(value)
      ) {
        callback(new Error('请输入91开头的18位统一社会信用代码'))
      } else if (
        this.infoForm.organizationType === 2 &&
        !/^92[A-Za-z0-9]{16}$/.test(value)
      ) {
        callback(new Error('请输入92开头的18位统一社会信用代码'))
        // } else if (
        //   this.infoForm.organizationType === 3 &&
        //   !/^[0-8][A-Za-z0-9]{17}$/.test(value)
        // ) {
        //   callback(new Error('非9开头的18位社会信用统一代码'))
      } else {
        callback()
      }
    },
    validLegalPersonName(rule, value, callback) {
      if (
        this.infoForm.mode === 3 &&
        !/^([\u4e00-\u9fa5]|·){2,30}$/.test(value)
      ) {
        callback(new Error('请输入正确的姓名'))
      } else if (
        this.infoForm.mode === 4 &&
        !/^([\u4e00-\u9fa5A-Za-z]|·){2,30}$/.test(value)
      ) {
        callback(new Error('请输入正确的姓名'))
      } else {
        callback()
      }
    },
    setMode() {
      this.$refs['infoForm'].clearValidate()
      if (this.infoForm.organizationType == 3) {
        this.infoForm.mode = 4
        this.infoForm.legalPersonIdentType = 0
      }
    },
    setIdenType(val) {
      this.$refs.infoForm.clearValidate(['legalPersonId'])
      this.infoForm.legalPersonId = null
      if (val !== 0) {
        this.infoForm.mode = 4
      }
    },
    getRoute() {
      this.$router.push({ name: 'agreements' })
    },
    getInfo() {
      this.$api
        .getInfo({
          flowId: this.infoData.flowId
        })
        .then(res => {
          if (res.code === '0') {
            let Num = 0
            let personNum = 0
            let authMode = res.data.availableAuthType.split(',')
            // let authMode = ['ENTERPRISE_BUSINESS_MAKE']
            this.flowType = res.data.flowType
            this.useCustomInfo = res.data.useCustomInfo
            authMode.forEach(v => {
              if (v === 'ENTERPRISE_LEGAL_PERSON') {
                this.authMode.push({
                  value: 3,
                  label: '法定代表人'
                })
                personNum = 1
              }
              if (
                v === 'ENTERPRISE_BUSINESS_MAKE' ||
                v === 'ENTERPRISE_BUSINESS_MAKE_OTHER'
              ) {
                if (!Num) {
                  Num = 1
                  this.authMode.push({
                    value: v === 'ENTERPRISE_BUSINESS_MAKE' ? 4 : 5,
                    label: '对公打款'
                  })
                }
              }
            })
            this.$set(
              this.infoForm,
              'mode',
              personNum === 1
                ? 3
                : (this.authMode[0] && this.authMode[0].value) || ''
            )
            console.log(this.infoForm.mode, this.authMode)
            // 是否有对公打款
            if (
              !authMode.includes('ENTERPRISE_BUSINESS_MAKE') &&
              !authMode.includes('ENTERPRISE_BUSINESS_MAKE_OTHER')
            ) {
              this.organizationType = [
                {
                  value: 1,
                  label: '企业',
                  title:
                    '企业指领取营业执照的有限责任公司、股份有限公司、非公司企业法人、国有企业、个人独资企业及其分支机构、来华从事经营活动和外国(地区)企业及其他经营单位'
                },
                {
                  value: 2,
                  label: '个体工商户',
                  title:
                    '个体工商户是指在法律允许的范围内，依法经核准登记，从事工商经营活动的自然人或者家庭'
                }
              ]
            }
            if (
              res.data.authStep === '5' ||
              res.data.authStep === '7' ||
              this.flowType === '2'
              // ||this.useCustomInfo
            ) {
              // 5是认证中  2重新认证  自定义
              this.$set(this.infoForm, 'companyName', res.data.companyName)
              this.$set(this.infoForm, 'licenseNo', res.data.licenseNo)
              this.$set(
                this.infoForm,
                'legalPersonName',
                res.data.legalPersonName
              )
              this.$set(this.infoForm, 'legalPersonId', res.data.legalPersonId)
              this.$set(
                this.infoForm,
                'organizationType',
                Number(res.data.organizationType)
              )
              this.$set(
                this.infoForm,
                'legalPersonIdentType',
                Number(res.data.legalPersonIdentType)
              )
              this.authMode.forEach(v => {
                if (v.value === Number(res.data.authMode)) {
                  this.$set(this.infoForm, 'mode', Number(res.data.authMode))
                  return false
                }
              })
              if (Number(res.data.organizationType) === 3) {
                //自定义数据-其他组织
                this.$set(this.infoForm, 'mode', 4)
              }
            }
            if (res.data.useCustomInfo) {
              this.$set(this.infoForm, 'companyName', res.data.companyName)
              this.$set(this.infoForm, 'licenseNo', res.data.licenseNo)
              this.$set(this.infoForm, 'organizationType', 1)
              switch (res.data.organizationType) {
                case '1':
                  this.organizationType = [
                    {
                      value: 1,
                      label: '企业',
                      title:
                        '企业指领取营业执照的有限责任公司、股份有限公司、非公司企业法人、国有企业、个人独资企业及其分支机构、来华从事经营活动和外国(地区)企业及其他经营单位'
                    }
                  ]
                  break
                case '2':
                  this.$set(this.infoForm, 'organizationType', 2)
                  this.organizationType = [
                    {
                      value: 2,
                      label: '个体工商户',
                      title:
                        '个体工商户是指在法律允许的范围内，依法经核准登记，从事工商经营活动的自然人或者家庭'
                    }
                  ]
                  break
                case '3':
                  this.$set(this.infoForm, 'organizationType', 3)
                  this.$set(this.infoForm, 'mode', 4)
                  this.organizationType = [
                    {
                      value: 3,
                      label: '其他组织',
                      title:
                        '其他组织指在中华人民共和国境内依法注册、依法登记的机关、事业单位、社会团体、学校和民办非企业单位和其他机构'
                    }
                  ]
                  break
              }
            }
          } else {
            return new Promise((resolve, reject) => {
              reject(res)
            })
          }
        })
        .catch(err => {
          if (err.code === '810404') {
            this.$alert(err.msg, '提示', {
              confirmButtonText: '好的',
              callback: () => {
                window.location.href = this.$store.state.userInfo.preWebUrl
              }
            })
          } else if (err.code !== '302') {
            this.$alert(err.msg, '提示', {
              confirmButtonText: '好的',
              callback: () => {}
            })
          } else {
            this.$alert(err.msg, '提示', {
              confirmButtonText: '好的',
              callback: () => {}
            })
          }
        })
    },
    setVerify() {
      this.$refs['infoForm'].validate(valid => {
        if (valid) {
          this.loading = true
          let data = {
            authMode: this.infoForm.mode,
            flowId: this.$store.state.userInfo.flowId,
            enterpriseInfo: {
              organizationType: this.infoForm.organizationType,
              companyName: this.infoForm.companyName,
              licenseNo: this.infoForm.licenseNo,
              legalPersonName: this.infoForm.legalPersonName,
              legalPersonId: this.infoForm.legalPersonId,
              legalPersonIdentType: this.infoForm.legalPersonIdentType
            }
          }
          this.$api
            .setAuthInfo(data)
            .then(res => {
              if (res.code && res.code === '0') {
                let param = { ...this.$store.state.userInfo }
                param.authSelectMode = this.infoForm.mode + ''
                this.$store.commit('SET_USERINFO', param)
                if (this.infoForm.mode === 4 && !this.infoData.havaAgentAuth) {
                  this.$router.push({ name: 'companySelectRemittanceType' })
                } else if (
                  this.infoForm.mode === 3 &&
                  !this.infoData.havaAgentAuth
                ) {
                  this.$router.push({ name: 'companyScanningCode' })
                } else {
                  this.$router.push({ name: 'companyAgentScanningCode' })
                }
              } else {
                return new Promise((resolve, reject) => {
                  reject(res)
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$alert(err.msg, '提示', {
                confirmButtonText: '好的',
                callback: () => {}
              })
            })
        }
      })
    },
    clearInterval() {
      for (let i of this.intervals) {
        clearInterval(i)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.entryInfoBody {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  background: #f1f3f7;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.entryInfoMain {
  width: 1600px;
  flex: 1;
  min-height: 660px;
  margin: 16px auto 0;
  background: #fff;
  padding: 0px 0 56px;
  position: relative;
}
.lineBtn {
  width: 1600px;
  background-color: #fff;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #eceef1;
  padding: 12px 0;
  text-align: center;
}
.infoArea {
  width: 580px;
  margin: 51px auto 0;
  .el-input,
  .el-select {
    width: 400px;
  }
  p {
    width: 408px;
    padding: 8px 12px;
    margin-top: 12px;
    background: #f1f5ff;
    border-radius: 2px;
    font-size: 12px;
    color: #595959;
    line-height: 22px;
  }
  ::v-deep.el-form-item__label {
    padding-right: 28px;
  }
  .verificationCode {
    width: 295px;
    margin-right: 8px;
  }
  .el-button.is-plain {
    background: #fff;
    border-color: #1c67f3;
    ::v-deep span {
      color: #1c67f3;
    }
    &.codeBtn.is-disabled {
      border-color: #eceff3;
      ::v-deep span {
        color: #c0c4cc !important;
      }
    }
  }
  .ornanizationTitle {
    height: 20px;
    line-height: 20px;
    display: inline-block;
    margin: 0;
    color: #d5dbe2;
    font-size: 16px;
  }
  .individualNo {
    ::v-deep.el-form-item__label {
      line-height: 18px;
    }
  }
}
</style>
<style lang="scss">
.organizationPopover {
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  .popper__arrow::after {
    // background-color: rgba(0, 0, 0, 0.7);
    border-bottom-color: rgba(0, 0, 0, 0.7) !important;
  }
}
</style>